import { Container } from 'react-bootstrap';
import './FAQAbout.css';

export const FAQAbout = () => {
  return (
    <div className="faq-about">
      <Container>
        <h4 className="faq-about-title">Frequently Asked Questions About Sticky Fingers Cooking</h4>
        <div className="faq-about-content">
          <p>
            Get answers to frequently asked questions about Sticky Fingers Cooking online classes,
            before and after school enrichment programs, and summer camps. Information about
            everything from drop off and pick up to recipes and kitchen tools.
          </p>
        </div>
      </Container>
    </div>
  );
};
